"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestDepartment = void 0;
var tslib_1 = require("tslib");
var model_1 = require("../model");
var batch_1 = require("./batch");
var cache_1 = require("./cache");
var fetchable_1 = require("./fetchable");
var collection_object_1 = require("./objects/collection.object");
var form_object_1 = require("./objects/form.object");
var object_1 = require("./objects/object");
var query_1 = require("./query");
var rest_1 = require("./rest");
var rest_department_attachment_1 = require("./rest.department.attachment");
var rest_department_image_1 = require("./rest.department.image");
var IkeRestDepartment = /** @class */ (function () {
    function IkeRestDepartment(boundUser, departmentId) {
        var _this = this;
        this.Objects = object_1.IkeRestObjects;
        this.Attachment = new rest_department_attachment_1.IkeRestDepartmentAttachment(this);
        this.Tag = {
            getById: function (objectId) { return _this.getOne(_this.Objects.Tag, 'uuid', objectId); },
            getByName: this.bindAction('tag.get'),
            getOrCreate: this.bindAction('tag.create'),
            Summary: {
                getById: function (objectId) { return _this.getOne(_this.Objects.TagSummary, 'objectId', objectId); }
            }
        };
        this.Event = {
            create: this.bindAction('event.create')
        };
        this.Calibration = {
            getById: function (objectId) { return _this.getOne(_this.Objects.Calibration, 'objectId', objectId); },
            create: this.bindAction('calibration.create')
        };
        this.Capture = {
            getById: function (objectId) { return _this.getOne(_this.Objects.Capture, 'objectId', objectId); },
            getByUuid: function (uuid) { return _this.getOne(_this.Objects.Capture, 'uuid', uuid); },
            Image: new rest_department_image_1.IkeRestDepartmentImage(this),
            data: this.bindAction('capture.data'),
            create: this.bindAction('capture.create'),
            antivirus: this.bindAction('capture.antivirus'),
            getMask: this.bindAction('collection.capture.mask.get')
        };
        this.AnnotationSummary = {
            getByUuid: function (uuid) { return _this.getOne(_this.Objects.AnnotationSummary, 'uuid', uuid); },
            getById: function (objectId) { return _this.getOne(_this.Objects.AnnotationSummary, 'collectionId', objectId); },
            getByRevision: function (revision) { return _this.getOne(_this.Objects.AnnotationSummary, 'revision', revision); },
            create: this.bindAction('annotation.summary.create')
        };
        this.CollectionSummary = {
            getByUuid: function (uuid) { return _this.getOne(_this.Objects.CollectionSummary, 'uuid', uuid); },
            getById: function (objectId) { return _this.getOne(_this.Objects.CollectionSummary, 'collectionId', objectId); },
            getByRevision: function (revision) { return _this.getOne(_this.Objects.CollectionSummary, 'revision', revision); },
            create: this.bindAction('collection.summary.create')
        };
        this.Collection = {
            getById: function (objectId) { return _this.getOne(_this.Objects.Collection, 'objectId', objectId); },
            getByUuid: function (uuid) { return _this.getOne(_this.Objects.Collection, 'uuid', uuid); },
            getByRevision: function (revision) { return _this.getOne(_this.Objects.Collection, 'revision', revision); },
            getModel: function (revision) { return _this.getModel(revision); },
            assign: this.bindAction('collection.assign'),
            Import: {
                csv: this.bindAction('collection.import.csv'),
                excel: this.bindAction('collection.import.excel')
            },
            export: this.bindAction('export'),
            exportImportableExcelTemplate: this.bindAction('export.importable.excel.template'),
            delete: this.bindAction('collection.delete'),
            duplicate: this.bindAction('collection.duplicate'),
            moveToJob: this.bindAction('collection.move.to.job'),
            moveToDepartment: this.bindAction('collection.move.to.department'),
            create: this.bindAction('collection.create'),
            search: this.bindAction('collection.search'),
            repair: this.bindAction('collection.repair'),
            revert: this.bindAction('collection.revert'),
            insightProcess: this.bindAction('department.insight.process'),
            migrate: this.bindAction('collection.migrate')
        };
        this.Department = {
            getById: this.bindAction('department.get.departmentid'),
            User: {
                getProfileById: function (objectId) { return _this.getOne(_this.Objects.UserProfile, 'objectId', objectId); },
                role: this.bindAction('department.user.role'),
                list: this.bindAction('department.user.list'),
                profile: this.bindAction('user.profile'),
                isLicensed: this.bindAction('user.is.licensed')
            },
            Invite: {
                createLegacy: this.bindAction('department.invite.create'),
                do: this.bindAction('department.invite'),
                list: this.bindAction('department.invite.list')
            }
        };
        this.Form = {
            getById: function (id) { return _this.getOne(_this.Objects.Form, 'objectId', id); },
            getByRevision: function (revision) { return _this.getOne(_this.Objects.Form, 'version', revision); },
            getModel: function (revision) { return _this.form('version', revision); },
            delete: this.bindAction('form.delete'),
            restore: this.bindAction('form.restore'),
            share: this.bindAction('form.share'),
            Pla: {
                getRefreshPermission: this.bindAction('refresh.form.ipf.license.check'),
                metadata: this.bindAction('form.pla.metadata'),
                import: this.bindAction('form.pla.import'),
                importPoleforeman: this.bindAction('form.pla.import.poleforeman'),
                savePoleForemanDb: this.bindAction('form.pla.import.save.poleforeman')
            },
            Summary: {
                list: this.bindAction('form.summary'),
                getByRevision: function (revision) { return _this.getOne(_this.Objects.FormSummary, 'revision', revision); }
            }
        };
        this.Verify = {
            revoke: this.bindAction('verify.revoke')
        };
        this.boundUser = boundUser;
        this.departmentId = departmentId;
        this.log = boundUser.log.child({ departmentId: departmentId });
        this.tokens = new fetchable_1.IkeFetchableMany(this.log, rest_1.IkeRest.createStore(), function () { return _this.query(object_1.IkeRestObjects.Token).find(); });
        this.tags = new fetchable_1.IkeFetchableMany(this.log, rest_1.IkeRest.createStore(), function () { return _this.query(object_1.IkeRestObjects.Tag).findAll(); });
        this.formSummaries = new fetchable_1.IkeFetchableMany(this.log, rest_1.IkeRest.createStore(), function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.action('form.summary')];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.results];
                }
            });
        }); });
        this.empty = new fetchable_1.IkeFetchableOne(this.log, rest_1.IkeRest.createStore(), function () { return Promise.resolve(null); });
        this.cache = new cache_1.IkeRestCacheControl();
        this.batcher = new batch_1.IkeRestBatchControl(this);
    }
    IkeRestDepartment.prototype.form = function (key, value) {
        var _this = this;
        var existing = this.cache.get(form_object_1.IkeObjectFormModel, key).get(key, value);
        if (existing == null) {
            existing = new fetchable_1.IkeFetchableTransform(this.log, rest_1.IkeRest.createStore(), this.getOne(object_1.IkeRestObjects.Form, key, value), function (formJSON) { return tslib_1.__awaiter(_this, void 0, void 0, function () { return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, model_1.IkeModel.Form.read(formJSON)];
            }); }); });
            this.cache.get(form_object_1.IkeObjectFormModel, key).set(key, value, existing);
        }
        return existing;
    };
    IkeRestDepartment.prototype.getModel = function (revision) {
        var _this = this;
        var existing = this.cache.get(collection_object_1.IkeObjectCollectionModel, 'revision').get('revision', revision);
        if (existing != null) {
            return existing;
        }
        var fetchable = new fetchable_1.IkeFetchableTransform(this.log, rest_1.IkeRest.createStore(), this.getOne(object_1.IkeRestObjects.Collection, 'revision', revision), function (c) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var cs, repaired, formModel, model;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(c == null)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.CollectionSummary.getByRevision(revision).fetch()];
                    case 1:
                        cs = _a.sent();
                        if (cs == null) {
                            throw new Error("Unable to fetch collection model with revision: ".concat(revision));
                        }
                        return [4 /*yield*/, this.CollectionSummary.create({ uuid: cs.uuid, repair: true })];
                    case 2:
                        repaired = _a.sent();
                        if (!repaired) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getOne(object_1.IkeRestObjects.Collection, 'uuid', cs.uuid).fetch()];
                    case 3:
                        c = _a.sent();
                        if (c == null) {
                            throw new Error("Unable to fetch collection model with uuid: ".concat(cs.uuid));
                        }
                        return [3 /*break*/, 5];
                    case 4: throw new Error("Unable to repair collection model with revision: ".concat(revision));
                    case 5: return [4 /*yield*/, this.form('version', c.formversion).fetch()];
                    case 6:
                        formModel = _a.sent();
                        model = model_1.IkeModel.Collection.read(c, formModel, this);
                        // Revision may change if collection was repaired
                        this.cache.get(collection_object_1.IkeObjectCollectionModel, 'revision').set('revision', model.revision, fetchable);
                        // TODO if we ever want a model to reference another collection model
                        // We cannot wait for it to be ready here.
                        return [4 /*yield*/, model.ready()];
                    case 7:
                        // TODO if we ever want a model to reference another collection model
                        // We cannot wait for it to be ready here.
                        _a.sent();
                        return [2 /*return*/, model];
                }
            });
        }); });
        this.cache.get(collection_object_1.IkeObjectCollectionModel, 'revision').set('revision', revision, fetchable);
        return fetchable;
    };
    IkeRestDepartment.prototype.action = function (path, data) {
        return this.boundUser.core._post(path, data, this.boundUser.accessToken, this.departmentId);
    };
    IkeRestDepartment.prototype.query = function (obj) {
        return new query_1.IkeRestQuery(this.boundUser.core, obj, this.boundUser.accessToken, this.departmentId, this.log);
    };
    IkeRestDepartment.prototype.save = function (obj, value, modifications, silent) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.action("".concat(obj.actionName, ".save"), tslib_1.__assign(tslib_1.__assign({ value: value }, modifications && { modifications: modifications }), { silent: silent }))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.results];
                }
            });
        });
    };
    /**
     * Get data from the API, generally should be called via the helper functions
     *  @see IkeDepartmentRest.Collection.getByRevision
     */
    IkeRestDepartment.prototype.getOne = function (obj, key, value) {
        var _this = this;
        var existing = this.cache.get(obj, key).get(key, value);
        if (existing == null) {
            var requestObj = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var result;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.batcher.batch(obj, key, value)];
                        case 1:
                            result = _a.sent();
                            if (obj.updateCache != null) {
                                obj.updateCache(key, result, this);
                            }
                            return [2 /*return*/, result];
                    }
                });
            }); };
            existing = new fetchable_1.IkeFetchableOne(this.log, rest_1.IkeRest.createStore(), requestObj);
            this.cache.get(obj, key).set(key, value, existing);
        }
        return existing;
    };
    /** Create a helper function to run a action */
    IkeRestDepartment.prototype.bindAction = function (path) {
        var _this = this;
        return function (data) { return _this.boundUser.core._post(path, data, _this.boundUser.accessToken, _this.departmentId); };
    };
    IkeRestDepartment.prototype.updateBoundUser = function (newBoundUser) {
        this.boundUser = newBoundUser;
    };
    return IkeRestDepartment;
}());
exports.IkeRestDepartment = IkeRestDepartment;
//# sourceMappingURL=rest.department.js.map